import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "../../gmanewstyle.module.css"; // ← use shared stylesheet
import logoimage from "../assets/Group -2.png";

const FRChangePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { levyAccountNumber, friendlyReminderActive, levyAccountId } =
    location.state || {};

  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [friendlyReminder, setFriendlyReminder] = useState(
    friendlyReminderActive
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // user access for navbar
  const [userAccess, setUserAccess] = useState([]);
  const [loadingAccess, setLoadingAccess] = useState(true);

  useEffect(() => {
    document.title = "GMA Portal || Friendly Letter Change";
  }, []);

  // fetch user access
  useEffect(() => {
    const fetchUserAccess = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/");
        return;
      }
      try {
        const decodedToken = JSON.parse(atob(token.split(".")[1]));
        const email = decodedToken.email || null;
        const contact_id = decodedToken.contact_id || null;

        if (!email) {
          setLoadingAccess(false);
          return;
        }

        const response = await fetch(
          "https://portal.gmacc.co.za/api/contact/determine-access/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ email, contact_id }),
          }
        );

        const data = await response.json();

        if (response.ok) {
          setUserAccess(data.access || []);
        }
      } catch (err) {
        // silent
      } finally {
        setLoadingAccess(false);
      }
    };

    fetchUserAccess();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccessMessage("");

    const token = localStorage.getItem("token");
    if (!token) {
      setError("Authentication failed. Please log in again.");
      navigate("/");
      return;
    }

    try {
      const response = await fetch(
        `https://portal.gmacc.co.za/api/update-friendly-reminder/${levyAccountId}/`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cj_sendfriendlyreminder: friendlyReminder,
          }),
        }
      );

      if (response.status === 401) {
        setError("Unauthorized request. Please log in again.");
        localStorage.removeItem("token");
        navigate("/");
      } else if (response.ok) {
        setSuccessMessage("✅ Friendly Reminder updated successfully!");
        setError("");
      } else {
        setError("❌ Failed to update Friendly Reminder.");
        setSuccessMessage("");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleOwnerPortalClick = () => navigate("/owner-portal");
  const handleTrusteePortalClick = () => navigate("/trustee-portal");
  const handleContractorPortalClick = () => navigate("/contractor-portal");

  return (
    <div className={styles.page}>
      {/* two-panel layout reusing existing portal classes */}
      <div className={styles.authFrame}>
        {/* left image (same image styling as other pages) */}
        <div className={styles.authMedia} aria-hidden="true"></div>

        {/* right panel */}
        <div className={styles.authPanel}>
          <div className={styles.formCard}>
            <img
              src={logoimage}
              alt="Gauteng Management Agents"
              className={styles.logImage}
            />
            <h2 className={styles.heading}>FRIENDLY REMINDER</h2>
            {levyAccountNumber && (
              <p className={styles.frAccount}>{levyAccountNumber}</p>
            )}

            <p className={styles.subhead}>
              Friendly Reminders are sent out monthly, around the 8th, at no
              cost. They notify you of any outstanding levy accounts before
              Credit Control procedures start.
            </p>
            <p>
              If the setting is <strong>Yes</strong>, our system will send a
              reminder for this account when necessary.
            </p>

            <form onSubmit={handleSubmit} className={styles.frForm}>
              <div className={styles.frField}>
                <label className={styles.inputShell}>Levy Account Number</label>
                <input
                  className={styles.input}
                  type="text"
                  value={levyAccountNumber || ""}
                  readOnly
                />
              </div>

              <div className={styles.frField}>
                <label className={styles.heading}>
                  Friendly Reminder Active
                </label>
                <select
                  value={friendlyReminder}
                  onChange={(e) =>
                    setFriendlyReminder(e.target.value === "true")
                  }
                >
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>

              {error && <p className={styles.errorText}>{error}</p>}
              {successMessage && (
                <p className={styles.successText}>{successMessage}</p>
              )}

              <button
                type="submit"
                className={styles.primaryButton}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </form>

            <p className={styles.backLink} onClick={() => navigate(-1)}>
              Back
            </p>
            <div className={styles.backLink} onClick={() => navigate("/#/")}>
              Log Out
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FRChangePage;
